// @flow
import React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import { push } from "connected-react-router"
import featureFlags from "global/feature-flags"
import withConnect from "hoc/withConnect"
import withMutation from "hoc/withMutation"
import withSubmit from "hoc/withSubmit"
import { createReservationMutation } from "data/reservations/graphql/mutations"
import Page from "pages/_Page"
import MainFilter from "pages/_Page/MainFilter"
import PlanBanner from "components/PlanBanner"
import Button from "components/Button"
import { Space } from "componentsStyled/Layout/Spacers"
import { WrapGrouper, Wrap } from "componentsStyled/Layout/Wrap"
import { Spread } from "componentsStyled/Layout/Flex"
import { VPaddedFullWidthContainer } from "componentsStyled/Layout/Containers"
import { PageTitle } from "componentsStyled/Typography/Titles"
import { Text } from "componentsStyled/Typography/Texts"
import ReservationSuccess from "modals/ReservationSuccess"
import { openModal } from "data/modals/actions"
import urls from "data/router/urls"
import { selectAppConfig, selectActivity, selectProductGroups, selectGeolocation } from "data/app/selectors"
import { selectSearchParams } from "data/search/selectors"
import { selectItems } from "data/basket/selectors"
import { clearBasket } from "data/basket/actions"
import type { PendingReservation } from "data/basket/types"
import type { Reservation, ReservationStatus } from "data/reservations/types"
import { getPlan } from "data/plans/helpers"
import withUser from "hoc/withUser"

import BasketTile from "./BasketTile"

function ShoppingBasketPage({ items, onClearBasket, onContinueShopping, submit, loading }) {
  function renderItem(item: PendingReservation, index: number) {
    return (
      <BasketTile key={index} pendingReservation={item} />
    )
  }

  return (
    <Page>
      <VPaddedFullWidthContainer narrow>
        <PageTitle>Shopping Cart</PageTitle>
        <Wrap>
          <Spread middle>
            <Text>
              There are {items.length} item(s) in your shopping cart
            </Text>
            <Button small secondary onClick={onClearBasket} loading={loading} disabled={loading}>
              Clear Cart
            </Button>
          </Spread>
        </Wrap>
        {items.map(renderItem)}
        <Wrap>
          <Button fullwidth onClick={submit} loading={loading} disabled={loading}>
            Complete Reservation
          </Button>
          <Space />
          <Button fullwidth secondary onClick={onContinueShopping} loading={loading} disabled={loading}>
            Continue Shopping
          </Button>
        </Wrap>
      </VPaddedFullWidthContainer>
    </Page>
  )
}

const mapStateToProps = state => ({
  items: selectItems(state),
})

const mapDispatchToProps = {
  openModal,
  clearBasket,
  push,
}

const enhancer: HOC<*, {||}> = compose(
  withConnect(mapStateToProps, mapDispatchToProps),
  withMutation(createReservationMutation),
  withHandlers({
    onClearBasket: props => (event) => {
      props.clearBasket()
    },
    onContinueShopping: props => (event) => {
      props.push(urls.products)
    }
  }),
  withSubmit({
    submit: props => () => {
      const response = props.items.map((item: PendingReservation) => {
        return props.submitMutation({
          input: {
            start: item.start,
            end: item.end,
            affiliateId: item.affiliate.affiliateId,
            productVariantId: item.productVariant.id,
            paymentMethod: item.paymentMethod,
            accessories: item.accessories.map(a => ({ name: a.name })),
            shippingAddress: item.shippingAddress,
            profileId: item.profileId,
          },
        })
      })
      return Promise.all(response)
    },
    redirect: (_, res) => urls.reservations,
    onSuccess: props => res => {
      props.clearBasket()
      props.openModal(ReservationSuccess, {})
    },
  })
)

export default enhancer(ShoppingBasketPage)



// WEBPACK FOOTER //
// ./src/pages/ShoppingBasket/index.js